import { render } from "./HostEnableDisable.vue?vue&type=template&id=45b96844&scoped=true"
import script from "./HostEnableDisable.vue?vue&type=script&lang=js"
export * from "./HostEnableDisable.vue?vue&type=script&lang=js"

import "./HostEnableDisable.vue?vue&type=style&index=0&id=45b96844&scoped=true&lang=css"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b96844"]])

export default __exports__